// GENERATED FILE, DO NOT EDIT
import { MyBaseCL } from "../MyBaseCL";
import { NotifySum, NotifyItem } from "../UiNotify";
export class NotifyCL extends MyBaseCL {
	public getNotifyCounts() : Promise<NotifySum[]> { return this.callMethod("getNotifyCounts", arguments, {"rawResult":false}); }
	public getNotifies(lastId: number|null, fromMe: boolean|null, limitCount: number) : Promise<NotifyItem[]> { return this.callMethod("getNotifies", arguments, {"rawResult":false}); }
	public saveFilter(filter: any) : Promise<any> { return this.callMethod("saveFilter", arguments, {"rawResult":false}); }
	public markAsViewed(lastId: number) : Promise<any> { return this.callMethod("markAsViewed", arguments, {"rawResult":false}); }
}
